'use client';
import Container from '@/components/ui/container';
import NextImage from '@/components/ui/next-image';
import EnvelopIcon from '@/components/ui/icons/envelop-icon';
import SubscribeIcon from '@/components/ui/icons/subscribe-icon';
import { useTranslations } from 'next-intl';
import { toast } from 'sonner';
import { subscribeToNewsletter } from '@/services/global/news-letter';
import { EmailValidation } from '@/utils/validation/subscribe';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { getCookie } from 'cookies-next';

const NewsLetter = () => {
  const t = useTranslations('common');
  const mage = getCookie('mage');

  return (
    <div className='relative flex w-screen items-center justify-center max-lg:max-h-[220px] max-lg:min-h-[220px] max-md:max-h-[180px] max-md:min-h-[180px] max-sm:max-h-[155px] max-sm:min-h-[155px]'>
      <NextImage
        className='absolute start-0 top-0 z-10 size-full object-cover'
        src='/imgs/layout/subscription.png'
        height={262}
        width={1920}
        alt='Bg subscription'
      />
      <Container className='relative z-30 flex max-w-96 flex-col items-center justify-center gap-3 lg:max-w-lg lg:gap-7 lg:py-12.5'>
        <div className='flex gap-3.5 lg:items-center lg:gap-12'>
          <EnvelopIcon className='max-lg:size-16 max-md:size-12 max-sm:h-9 max-sm:w-10 lg:h-17.5 lg:w-20' />
          <div className='flex flex-col gap-1'>
            <h2 className='text-xs font-bold sm:text-base lg:text-xl'>
              {t('Sign Up for Newsletter')}
            </h2>
            <p className='text-xs leading-6 max-lg:line-clamp-2 sm:text-sm'>
              {t('You have always got info about a sets of our products')}
            </p>
          </div>
        </div>
        <Formik
          initialValues={{ email: '' }}
          validationSchema={EmailValidation(t)}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            setSubmitting(true);
            const res = await subscribeToNewsletter(mage, values.email);
            if (res.status == 200) {
              !res.data.data?.[0]?.error
                ? toast.success(t('Thank you for your subscription'))
                : toast.error(
                    t(res.data.data?.[0]?.message?.replace(/\.$/, '')) ||
                      t('This email address is already subscribed')
                  );
            } else {
              toast.error(
                t(res.data.data?.[0]?.message?.replace(/\.$/, '')) ||
                  t('This email address is already subscribed')
              );
            }

            setSubmitting(false);
            resetForm();
          }}
        >
          {({ isSubmitting }) => (
            <Form className='w-full'>
              <div className='flex h-9 items-center gap-3 rounded-md bg-white ps-3.5 pe-2 sm:h-10 lg:h-13.5 lg:gap-6'>
                <Field
                  name='email'
                  placeholder={t('Enter your email here')}
                  className='flex-1 text-xs outline-none placeholder:text-xs max-sm:px-3 sm:text-sm sm:placeholder:text-sm lg:ps-7.5'
                />
                <button
                  type='submit'
                  disabled={isSubmitting}
                  className='disabled:bg-primary/35 flex h-full w-9 cursor-pointer items-center justify-center rounded-md bg-red-600 py-1.5 text-sm text-white uppercase hover:bg-red-600/50 disabled:cursor-not-allowed sm:w-11 lg:h-10 lg:w-36'
                >
                  <span className='flex items-center justify-center max-lg:hidden'>
                    {isSubmitting ? (
                      <span className='border-primary-500 size-4 animate-spin rounded-full border-t border-r py-1 max-lg:size-2' />
                    ) : (
                      t('Subscribe')
                    )}
                  </span>
                  <SubscribeIcon className='size-3.5 lg:hidden' />
                </button>
              </div>
              <ErrorMessage
                name='email'
                component='p'
                className='text-xs font-bold text-red-600 md:text-sm'
              />
            </Form>
          )}
        </Formik>
      </Container>
    </div>
  );
};

export default NewsLetter;
